import React from 'react';
import { arrayOf, object } from 'prop-types';
import styled from 'styled-components';
import shortid from 'shortid';

import BenefitItem from './BenefitItem';

const Container = styled.div`
  display: none;

  @media(min-width: 1000px) {
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    width: 976px;
  }
`;

const BenefitList = ({ benefits }) => (
  <Container>
    {benefits.map(benefit => <BenefitItem key={shortid.generate()} benefit={benefit} />)}
  </Container>
);

export default BenefitList;

BenefitList.propTypes = {
  benefits: arrayOf(object).isRequired,
};
